import { render, staticRenderFns } from "./RoomCrud.vue?vue&type=template&id=8a6f3a68&"
import script from "./RoomCrud.vue?vue&type=script&lang=js&"
export * from "./RoomCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports